import { Link, LinkProps } from '@ampcore/adel-react'
import React, { forwardRef } from 'react'

import { DisplayForRule } from '../../types/DisplayForRule.type'
import { UserStatus } from '../../types/UserStatus.enum'

export type ConditionalLinkProps = LinkProps & {
  displayFor?: DisplayForRule
  userStatus: UserStatus
}

export const ConditionalLink = forwardRef<
  HTMLAnchorElement,
  ConditionalLinkProps
>(({ displayFor, userStatus, ...linkProps }, ref) => {
  let visible = true
  if (displayFor) {
    if (displayFor.mode === 'show') {
      visible = displayFor.statuses.includes(userStatus)
    } else if (displayFor.mode === 'hide') {
      visible = !displayFor.statuses.includes(userStatus)
    }
  }
  if (!visible) return null
  return <Link ref={ref} {...linkProps} />
})
